const getValueByParameterCaseInsensitive = (object, key) => {
  return object[
    Object.keys(object).filter(function(k) {
      return k.toLowerCase() === key.toLowerCase();
    })[0]
  ];
};

const withTrailingSlash = url => url.replace(/\/?$/, "/");

export { getValueByParameterCaseInsensitive, withTrailingSlash };

// polyfill for IE11
export function endsWith(str, suffix) {
  return str.indexOf(suffix, str.length - suffix.length) !== -1;
}
